// Дефолтная касса для форм оплат: первая активная касса с валютой.
// Возвращает безопасную заглушку {} вместо null: шаблоны и инициализация paymentData
// разыменовывают company_cashbox.currency_id, и null ронял рендер у компаний без касс.
export function resolveDefaultCashbox(cashboxes) {
  const first = cashboxes && cashboxes[0];
  return first && first.currency_id ? first : {};
}
